// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__19Gm4","checkboxCol":"Table_checkboxCol__1GVKG","emailCol":"Table_emailCol__1mbD3","actionCol":"Table_actionCol__3dsUh"};